import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { GraphQLModule } from './graphql.module';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    GraphQLModule
  ],
  exports: [
    GraphQLModule
  ]
})
export class CoreModule { }
